var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.16,
    height: 24,
    viewBox: "0 0 24.16 24",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,11.38h12a.78.78,0,1,0,0-1.55H6.1a.78.78,0,1,0,0,1.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,8h12a.78.78,0,1,0,0-1.55H6.1A.78.78,0,1,0,6.1,8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1,14.75H12a.78.78,0,1,0,0-1.55H6.1a.78.78,0,1,0,0,1.55Z",
    fill: "#e30613"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.57,1.35h-19A2.59,2.59,0,0,0,0,3.93V16.37a.78.78,0,1,0,1.55,0V3.93a1,1,0,0,1,1-1h19a1,1,0,0,1,1,1V17.25a1,1,0,0,1-1,1H3.81c-.35,0-.68.23-3,2.49a.78.78,0,0,0,0,1.1.77.77,0,0,0,1.1,0L4,19.83H21.57a2.59,2.59,0,0,0,2.59-2.59V3.93A2.59,2.59,0,0,0,21.57,1.35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokSend);
export default __webpack_public_path__ + "static/media/hok-send.53b67e7429134dd530368804debb7463.svg";
export { ForwardRef as ReactComponent };